<template>
	<div
		class="video-actions"
		v-if="isPaid(get('video')) || isFree(get('video'))"
	>
		<button
			class="action-btn"
			@click="like(true, get('video').id)"
		>
			<v-icon size="18">mdi-thumb-up-outline</v-icon>
			<span>{{ get('video').likes }}</span>
		</button>

		<button
			class="action-btn"
			@click="like(false, get('video').id)"
		>
			<v-icon size="18">mdi-thumb-down-outline</v-icon>
			<span>{{ get('video').dislikes }}</span>
		</button>

		<button
			class="action-btn"
			@click="openModal('socialSharing')"
		>
			<v-icon size="18">mdi-share</v-icon>
			<span>{{ $t('common.share') }}</span>
		</button>

		<!-- <button
			class="action-btn"
			@click="setVidFav(get('video').id)"
		>
			<v-icon size="18">mdi-star</v-icon>
			<span>Merken</span>
		</button> -->
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import APIService from '@/services/api.service';
import AppService from '@/services/app.service';
import vActions from '@/components/player/videoInsightsActions/vActions';

export default {
	name: 'vActions',
	extends: vActions,

	data() {
		return {
			videoFav: false,
			vFavText: false,
			vFavTextUnset: false,
			vLikeText: false,
			vDislikeText: false
		}
	},

	computed: { ...mapGetters(["get"]) },

	components: {
		socialSharing: () => import('@/components/modal/socialSharing')
	},

	methods: {

		shareLink(item) {
			return `${window.location.protocol}//${window.location.host}/videos/${item.id}`;
		},

		// Actions
		setVidFav(videoId) {
			this.videoFav = !this.videoFav
			this.$store.dispatch('patch',
				{
					endpoint: `/api/v1/users/${this.$store.state.main.user.result.id}`,
					event: { favorits: [videoId] },
					message: false
				})
				.then(() => {
					this.$store.dispatch('fetch', { endpoint: `/api/v1/users/me`, state: 'user' })
				})
			APIService.setResponse({ message: this.$t('user.dashboard.fav_added'), color: 'green' })
			// console.log("Save Video als Fav -> heroVideoInsights");
		},

		deleteFavVid(videoId) {
			this.$store.dispatch('delete', {
				endpoint: `/api/v1/favorits/${videoId}`,
				message: false
			}).then(() => {
				this.$store.dispatch('fetch', { endpoint: `/api/v1/users/me`, state: 'user' })
				APIService.setResponse({ message: this.$t('user.dashboard.fav_removed'), color: 'green' })
			})
		},

		isFav(item) {
			let fav = false;
			const favorits = this.$store.state.main.user.result.favorits;
			favorits.forEach((favorit) => {
				favorit.videos.forEach((video) => {
					if (video.id === item.id) {
						fav = true;
					}
				});
			});
			return fav;
		},

		like(value, id) {
			this.$store.dispatch('post',
				{
					endpoint: `/api/v1/reviews`,
					event: { video: id, like: value },
					state: 'reviews',
					message: false
				})
				.then(() => {
					this.$store.dispatch('fetch', { endpoint: `/api/v1/videos/${this.$store.state.main.video.result.id}`, state: 'video' })
				})
				.catch(() => {
					APIService.setResponse({ message: this.$t('shop.video_shop.already_reviewed'), color: "red" })
				})
		},

		isPaid(item) {
			let paid = false;
			if (this.$store.state.main.user.result) {
				if (item.subscription) {
					// Status-aware check. A suspended or expired row grants no
					// access. AppService.isSubscription() applies this rule.
					paid = AppService.isSubscription(item);
				}
				else {
					const paidOrders = this.$store.state.main.user.result.orders
					paidOrders.forEach((order) => {
						order.videos.forEach((video) => {
							if (video.id === item.id) {
								paid = true;
							}
						});
					});
				}
			}
			return paid
		},

		isFree(item) {
			let free = false;
			if (item.price == 0 && item.subscription == false) {
				free = true;
			}
			return free;
		},

		openModal(name) {
			this.$store.dispatch("modal/open", name)
		},

	}

}
</script>


<style scoped>
.video-actions {
	display: flex;
	align-items: center;
	gap: 8px;
}

.action-btn {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 6px 12px;
	background: transparent;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 6px;
	font-size: 14px;
	cursor: pointer;
	transition: background 150ms ease, border-color 150ms ease;
}

.action-btn:hover {
	background: rgba(0, 0, 0, 0.04);
	border-color: rgba(0, 0, 0, 0.2);
}

.theme--dark .action-btn {
	border-color: rgba(255, 255, 255, 0.12);
	color: rgba(255, 255, 255, 0.87);
}

.theme--dark .action-btn:hover {
	background: rgba(255, 255, 255, 0.08);
	border-color: rgba(255, 255, 255, 0.2);
}

.action-btn .v-icon {
	opacity: 0.7;
}
</style>
